import { render, staticRenderFns } from "./AlbumImageField.vue?vue&type=template&id=dfa09178&scoped=true"
import script from "./AlbumImageField.vue?vue&type=script&lang=ts"
export * from "./AlbumImageField.vue?vue&type=script&lang=ts"
import style0 from "./AlbumImageField.vue?vue&type=style&index=0&id=dfa09178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa09178",
  null
  
)

export default component.exports